var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAuthyIcn = function SvgAuthyIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#authy-icn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 24c0 13.255-10.745 24-24 24S0 37.255 0 24 10.745 0 24 0s24 10.745 24 24Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.941 18.914 5.755 5.752a2.13 2.13 0 0 0 3.012-3.01L24.953 15.9c-4.118-4.12-10.773-4.185-14.978-.21a1.8 1.8 0 0 0-.113.103c-.019.018-.034.038-.052.054l-.056.052c-.036.037-.07.075-.1.112-3.979 4.207-3.91 10.863.208 14.981l5.755 5.754a2.13 2.13 0 0 0 3.013-3.011l-5.755-5.755a6.492 6.492 0 0 1-.052-9.12 6.491 6.491 0 0 1 9.118.053Zm7.428-7.664a2.127 2.127 0 0 0 .002 3.011l5.753 5.755a6.493 6.493 0 0 1 .05 9.12 6.491 6.491 0 0 1-9.117-.054l-5.755-5.754a2.13 2.13 0 1 0-3.012 3.012l5.753 5.756c4.119 4.118 10.773 4.185 14.979.209.039-.035.076-.067.114-.103l.051-.055c.02-.017.038-.034.055-.054a1.17 1.17 0 0 0 .101-.111c3.978-4.205 3.911-10.858-.207-14.98l-5.754-5.752a2.129 2.129 0 0 0-3.013 0Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "authy-icn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default SvgAuthyIcn;